import { Images } from "../../../Images";
import MineDamageLogic from "../../../logic/MineDamageLogic";
import { Settings } from "../../../Settings";
import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import ClassicUpgradeCollection from "../classic/ClassicUpgradeCollection";
import DamageBonusGoldUpgrade from "./DamageBonusGoldUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import OreBonusGoldUpgrade from "./OreBonusGoldUpgrade";
import ClassicUpgradeCostCalculator from "../classic/ClassicUpgradeCostCalculator";
import Damage from "../../crew/Damage";
import GoldBonusGoldUpgrade from "./GoldBonusGoldUpgrade";

export default class GoldUpgradeCollection extends ClassicUpgradeCollection {
    /**
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    constructor(totals, values, mineDamageLogic, damage) {
        super();

        this.initializeUpgrades(totals, values, mineDamageLogic, damage);
    }

    /**
     * @override
     * @param {Totals} totals 
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    initializeUpgrades(totals, values, mineDamageLogic, damage) {

        this.generateDamageBonusUpgrade('goldDamage', totals, this.createCostCalculator(0), mineDamageLogic, damage);
        this.generateOreBonusUpgrade('goldOre', totals, this.createCostCalculator(0), values);

        this.generateOreDamageBonusUpgrade('goldOreMulti', totals, this.createCostCalculator(1), mineDamageLogic, damage);
        this.generateMinedDamageBonusUpgrade('goldMinedDamage', totals, this.createCostCalculator(1), mineDamageLogic, damage);
        
        this.generatePrestigeDamageBonusUpgrade('goldPrestigeDamage', totals, this.createCostCalculator(2), mineDamageLogic, damage);
        this.generateDepthDamageBonusUpgrade('goldDepthDamage', totals, this.createCostCalculator(2), mineDamageLogic, damage);

        this.generateRubyDamageBonusUpgrade('goldRubyDamage', totals, this.createCostCalculator(3), mineDamageLogic, damage);
        this.generateBlockDamageBonusUpgrade('goldBlockDamage', totals, this.createCostCalculator(3), mineDamageLogic, damage);

        this.generateBaseDamageBonusUpgrade('goldBaseDamage', totals, this.createCostCalculator(4), mineDamageLogic, damage);

        this.generateGoldBonusUpgrade('goldPerBlock', totals, this.createCostCalculator(8), values);

        // gold per block

        this.addBulkCompleted();
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Mine: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldDamageMultiplier);

        this.addBulk(upgrade);
    }


    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateBaseDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Base Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldBaseDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateOreDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Ore Multi: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldOreDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateMinedDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Mined Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldMinedDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generatePrestigeDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Prestige Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldPrestigeDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateDepthDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Depth Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldDepthDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateRubyDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Ruby Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldRubyDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     */
    generateBlockDamageBonusUpgrade(id, totals, costCalculator, mineDamageLogic, damage) {
        const upgradeMultiplier = Settings.gold.damageMultiplierPerUpgrade;

        const upgrade = new DamageBonusGoldUpgrade(id, 'Block Damage: x' + upgradeMultiplier, Images.pick, 
            costCalculator, 100, totals, mineDamageLogic, damage, damage.goldBlockDamageMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Values} values
     */
    generateOreBonusUpgrade(id, totals, costCalculator, values) {
        const upgradeMultiplier = Settings.gold.oreBonusMultiplierPerUpgrade;

        const upgrade = new OreBonusGoldUpgrade(id, 'Ore: x' + upgradeMultiplier, Images.currency.ore, 
            costCalculator, 100, totals, values.goldOreBonusMultiplier);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {string} id
     * @param {Totals} totals 
     * @param {CostCalculator} costCalculator
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Values} values
     */
    generateGoldBonusUpgrade(id, totals, costCalculator, values) {

        const upgrade = new GoldBonusGoldUpgrade(id, 'Gold: +1/block', Images.currency.gold, 
            costCalculator, 100, totals, values.goldPerBlockBonus);

        this.addBulk(upgrade);
    }

    /**
     * @private
     * @param {number} adjustmentLevel
     * @returns {UpgradeCostCalculator}
     */
    createCostCalculator(adjustmentLevel) {
        const costGrowthRate = 1.4;

        const baseCost = Settings.gold.upgradeBaseCost + (adjustmentLevel * Settings.gold.upgradeBaseCostAdjustment);

        return new ClassicUpgradeCostCalculator(new BigNum(baseCost), costGrowthRate);
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetForPrestige() {
        // DO NOT RESET THIS UPGRADE COLLECTION WHEN WE PRESTIGE.
        // No call to super.
    }

}